import React from "react"
import { Button, Icon, Image } from "semantic-ui-react"
import logo from "../assets/bruneau_logo.png"

export const getBruneauRefButton = (
  isgUrl: string,
  r?: string,
  isRefStock?: boolean
) => {
  if (r) {
    const refLink = isgUrl + r
    const onRefLinkClick = (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      window.open(refLink, "_blank")
    }
    return (
      <Button className="hoverable ref-search-bruneau" onClick={onRefLinkClick}>
        {(!isRefStock && <Image size="mini" src={logo} />) || (
          <Icon name="warehouse" style={{ margin: 0, color: "#e42313" }} />
        )}
      </Button>
    )
  }
  return <></>
}
